import React, { useState, useEffect, useContext, FormEvent, ChangeEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { getAuth, User } from "firebase/auth";
import { AuthContext } from "../../authProvider/authProvider";
import {
  getFirestore,
  doc,
  updateDoc,
  setDoc,
  collection,
  Timestamp,
  onSnapshot,
  getDoc,
  DocumentData,
} from "firebase/firestore";
import { auth, app, host } from "../../../config";
import Roleeee from "../role";
import UserSearch from "../UserSearch";
import "./adminGroupChecker.css";
import CircularProgress from "@mui/material/CircularProgress";
import Main from "components/main/main";

interface DocData {
  Role?: string;
  Suspended?: boolean;
}

const AdminGroupCheck: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [selectedRole, setSelectedRole] = useState<string>("employer");
  const [firstname, setFirstname] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const auth2 = getAuth();
  const navigate = useNavigate(); // Hook to navigate between routes

  const authContext = useContext(AuthContext); // Get Auth context
  if (!authContext) {
    throw new Error("AuthContext is undefined");
  }
  const { currentUser, role, suspended } = authContext; // Get current user from Auth context

  var tk: string;
  currentUser
    ?.getIdToken(false)
    .then((idToken: string) => {
      tk = idToken;
    })
    .catch((error: any) => {
      console.log(error);
    });

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (role !== "admin") {
    return <Navigate to="/basePage" />;
  }

  if (suspended === true) {
    return <Navigate to="/login" />;
  }

  const goToDashboard = () => {
    navigate("/dashboard");
  };

  const goBack = () => {
    if (role === "admin") {
      navigate("/adminPanel");
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (password.length < 6) {
      alert("password needs to be at least 6 characters");
    }

    try {
      let data = {
        Email: email,
        Password: password,
        FirstName: firstname,
        LastName: lastname,
        Role: selectedRole,
      };

      setIsLoading(true);

      fetch(`${host}/api/firebase/api/CData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${tk}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then(async (data: any) => {
          // console.log(data)
          //console.log("trigger")
          if (data.message === "Email used") {
            alert("Email Already in use");
          }

          setEmail("");
          setPassword("");
          setSelectedRole("employee");
          setFirstname("");
          setLastname("");
          try {
            alert("Account successfully created");
          } catch (error) {
            console.error("Error:", error);
            alert(error);
          }
        })
        .catch((error: any) => console.error("Error:", error))
        .finally(() => {
          setIsLoading(false);
          console.log("Processing finished");
        });
    } catch (error) {
      setIsLoading(false);
      console.error("Error:", error);
    }
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <div className="admin-portal-container">
        <button className="back-buttonAddUser" onClick={goBack}>
          Back
        </button>
        <div className="headerAdminCard">
          <h1>Group Search</h1>
          <p className="adminUserNote">Check for groups under User based on email</p>
        </div>
        <div className="section-style2">
          <Main />
        </div>
      </div>
    </>
  );
};

export default AdminGroupCheck;
